var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 155,
    viewBox: "0 0 155 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 77.5,
    cy: 77.5,
    r: 74.5,
    fill: "#222222"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.2782 45.9453L62.3191 66.2534C59.5469 69.2054 58 73.1309 58 77.2134C58 81.296 59.5469 85.2214 62.3191 88.1735L82.2782 108.482C83.5031 109.728 85.1645 110.428 86.8968 110.428C88.6291 110.428 90.2905 109.728 91.5155 108.482C92.7404 107.235 93.4286 105.545 93.4286 103.783C93.4286 102.021 92.7404 100.331 91.5155 99.0848L71.5521 78.7766C71.1441 78.3614 70.9148 77.7983 70.9148 77.2112C70.9148 76.6241 71.1441 76.061 71.5521 75.6458L91.5155 55.3421C92.7404 54.096 93.4286 52.406 93.4286 50.6437C93.4286 48.8815 92.7404 47.1914 91.5155 45.9453C90.2905 44.6992 88.6291 43.9992 86.8968 43.9992C85.1645 43.9992 83.5031 44.6992 82.2782 45.9453Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewArrowLeft);
export default __webpack_public_path__ + "static/media/new-arrow-left.ba03a131e38411499f61ffd0804cffd1.svg";
export { ForwardRef as ReactComponent };